import type { ReactElement, FC } from 'react'

interface MainLayoutProps {
  leftNav: ReactElement
}

const AppLayout: FC<MainLayoutProps> = ({ leftNav, children }) => {
  return (
    <div data-testid='sparky-oneapp' className='sparky-oneapp spf-flex spf-flex-row spf-h-screen'>
      <div data-testid='sparky-left-nav' className='sparky-left-nav panwds-tw3 panwds-unset-reboot spf-flex-0 spf-z-[1000]'>
        {leftNav}
      </div>
      <div
        id='mainframe'
        data-testid='sparky-main-body'
        className='sparky-main-body spf-w-full spf-h-screen spf-flex spf-flex-grow spf-relative spf-overflow-auto spf-bg-gray-100 dark:spf-bg-gray-950'
      >
        {children}
      </div>
    </div>
  )
}

export default AppLayout
